<template>
  <div class="header-nav-wrapper hide-for-medium">
    <header class="header-nav">
      <div class="header-nav__left">
        <button @click="toggleFilter">
          <ArrowLeftSvg />
        </button>
      </div>

      <div class="header-nav__center">
        {{ label }}
      </div>

      <div class="header-nav__right">
        <slot></slot>
      </div>
    </header>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import ArrowLeftSvg from '@/images/arrow_left.svg';

defineProps({
  label: { type: String, required: true },
});

const emit = defineEmits(["toggle"]);

function toggleFilter() {
  emit("toggle", true);
}
</script>
